import React, { useState, useEffect } from 'react';

import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';
import { AxiosError } from 'axios';

import TopPanel from '../components/utils/TopPanel';
import * as Service from '../services/VendorsService';
import StripeAccountsList from '../components/stripe/StripeAccountsList';
import FareharborCompaniesModal from '../components/fareharborItems/FareharborCompaniesModal';
import Succsess from '../components/stateMessage/Succsess';
import { Company, StripeAccount } from '../types/Stripe';

/* eslint-disable no-shadow */

const StyledLoaderWrapper = styled.div`
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 30%;
  margin: auto;
`;

const StripeAccounts = () => {
  const [loading, setLoading] = useState(false);
  const [stripeAccounts, setStripeAccounts] = useState<StripeAccount[]>([]);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [selectedStripeAccountId, setSelectedStripeAccountId] = useState<
    string | null
  >(null);
  const [wasAssociated, setWasAssociated] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [stripeAccounts, companies] = await Promise.all([
        Service.getStripeConnectedAccounts(),
        Service.getFareHarborCompanies(),
      ]);
      setStripeAccounts(stripeAccounts);
      setCompanies(companies);
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onAssociate = async companyToAssociateWith => {
    try {
      setWasAssociated(false);
      setLoading(true);
      await Service.associateStripeAccountWithFareharborCompany(
        selectedStripeAccountId,
        companyToAssociateWith
      );
      setSelectedStripeAccountId(null);
      setWasAssociated(true);
      setTimeout(() => {
        setWasAssociated(false);
      }, 1500);
      fetchData();
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {wasAssociated && (
        <Succsess text='Stripe Account was successfully associated' />
      )}
      {selectedStripeAccountId && (
        <FareharborCompaniesModal
          closeModal={() => setSelectedStripeAccountId(null)}
          onCancel={() => setSelectedStripeAccountId(null)}
          companies={companies}
          onAssociate={companyToAssociateWith =>
            onAssociate(companyToAssociateWith)
          }
        />
      )}
      <TopPanel>
        <h1 className='col-md-6 col-sm-4 col-xs-3'>
          <span className='fas fa-beer' /> Stripe Accounts
        </h1>
      </TopPanel>
      {loading && (
        <StyledLoaderWrapper>
          <Glyphicon key={0} glyph='refresh' className='spinning' />
        </StyledLoaderWrapper>
      )}
      {stripeAccounts.length > 0 && (
        <div className='table-box tab-cont'>
          <StripeAccountsList
            stripeAccounts={stripeAccounts}
            setSelectedStripeAccountId={setSelectedStripeAccountId}
          />
        </div>
      )}
    </>
  );
};

export default StripeAccounts;
